import { render, staticRenderFns } from "./DemeraraMutualForm.vue?vue&type=template&id=2fd38712"
import script from "./DemeraraMutualForm.vue?vue&type=script&lang=js"
export * from "./DemeraraMutualForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports